import { IState } from '../../../../store/types';
import { connect } from 'react-redux';
import { PhraseListSelectVideo } from '../components/PhraseListSelectVideo';
import { IPhraseListSelectVideoEvents, IPhraseListSelectVideoFields } from '../components/types';
import { PhraseListSelectVideoEvents } from './events';
import { PhraseListSelectors } from '../../../../store/phrase-list/selectors';
import { VocabularyComponentUtils } from '../../Vocabulary/vocabulary/utils/VocabularyComponentUtils';
import { isPhrasesExist } from '../../../../store/general/selectors';

const mapStateToProps = (
	dispatch: any
) => {
	return (
		state: IState
	): IPhraseListSelectVideoFields => {
		
		const listMode = PhraseListSelectors.getListMode(state);
    	const listModeLang = PhraseListSelectors.getListModeLang(state);
		const listModes = VocabularyComponentUtils.getListModes(state);
		const activeListMode = VocabularyComponentUtils.getListMode(state, listMode, listModeLang) ||
			  VocabularyComponentUtils.getDefaultListMode(state);

		return {
			activeListModeId: activeListMode.id,
			listModes,
		}
	};
}

const mapDispatchToProps = (
	dispatch: any,
): IPhraseListSelectVideoEvents => ({
	onChangeListMode: (id) => dispatch(PhraseListSelectVideoEvents.onChangeListMode(id)),
});

export const PhraseListSelectVideoHOC = connect(
	mapStateToProps,
	mapDispatchToProps
)(PhraseListSelectVideo) as any;

PhraseListSelectVideoHOC.displayName = 'PhraseListSelectVideoHOC';
